import React from "react";
import { useModal } from "hooks/useModal";
import { Button } from "components/DesignSystem/Button/Button";
import { Task1120BulkServiceTeamUpdateModal } from "components/TaskTracker/Task1120BulkServiceTeamUpdateModal";
import { Task1120BulkPreparerUpdateModal } from "components/TaskTracker/Task1120BulkPreparerUpdateModal";
import { Task1120BulkETDUpdateModal } from "components/TaskTracker/Task1120BulkETDUpdateModal";
import { TaskBulkTagAssign } from "components/TaskTracker/TaskBulkTagAssign";
import { motion } from "framer-motion";
import { UpdateBulkTaskDeadline } from "./UpdateBulkTaskDeadline";
import { DividerLine } from "components/icons/DividerLine";

export const AllFilingBulkAction = ({
  selectedRows,
  resetSelection,
  selectedRowsServiceTeam,
  exportingCsv,
  onExportCSV,
  canUpdateDeadline,
}: {
  selectedRows: string[];
  resetSelection: () => void;
  selectedRowsServiceTeam: string[];
  exportingCsv: boolean;
  onExportCSV: () => void;
  canUpdateDeadline: boolean;
}) => {
  const serviceTeamAssignModal = useModal();
  const preparerAssignModal = useModal();
  const estimatedDeliveryTimeModal = useModal();
  const tagUpdateModal = useModal();
  const deadlineUpdateModal = useModal();
  const canAddETD = selectedRowsServiceTeam.length === selectedRows.length;
  const canAssignPreparer =
    canAddETD && new Set(selectedRowsServiceTeam).size === 1;

  return (
    <motion.span
      initial={{ opacity: 0, y: -10 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ ease: "easeInOut", duration: 0.2 }}
      key={selectedRows.toString()}
      className="t-flex t-gap-3 t-items-center"
    >
      <div className="t-text-subtext t-text-text-30">Update:</div>
      <Button size="xsmall" onClick={serviceTeamAssignModal.open}>
        Service Team
      </Button>
      <Button
        size="xsmall"
        onClick={estimatedDeliveryTimeModal.open}
        disabled={!canAddETD}
      >
        ETD
      </Button>
      <Button
        size="xsmall"
        onClick={preparerAssignModal.open}
        disabled={!canAssignPreparer}
      >
        Preparer
      </Button>
      <Button size="xsmall" onClick={tagUpdateModal.open}>
        Tags
      </Button>
      <Button
        size="xsmall"
        onClick={deadlineUpdateModal.open}
        disabled={!canUpdateDeadline}
      >
        Deadline
      </Button>{" "}
      <span className="t-text-neutral-10 t-h-full">
        <DividerLine />
      </span>
      <Button
        size="xsmall"
        isLoading={exportingCsv}
        disabled={exportingCsv}
        onClick={onExportCSV}
      >
        Generate 7004 CSV
      </Button>
      <Task1120BulkServiceTeamUpdateModal
        {...serviceTeamAssignModal}
        selectedRows={selectedRows}
        resetSelection={resetSelection}
      />
      <Task1120BulkPreparerUpdateModal
        {...preparerAssignModal}
        selectedRows={selectedRows}
        resetSelection={resetSelection}
        serviceTeamId={selectedRowsServiceTeam?.[0]}
      />
      <Task1120BulkETDUpdateModal
        {...estimatedDeliveryTimeModal}
        selectedRows={selectedRows}
        resetSelection={resetSelection}
      />
      <TaskBulkTagAssign
        {...tagUpdateModal}
        selectedRows={selectedRows}
        resetSelection={resetSelection}
      />
      <UpdateBulkTaskDeadline
        {...deadlineUpdateModal}
        selectedRows={selectedRows}
        resetSelection={resetSelection}
      />
    </motion.span>
  );
};
